import { render, staticRenderFns } from "./PageSocialPartial.htm?vue&type=template&id=d506842c&scoped=true&external"
import script from "./PageSocialPartial.js?vue&type=script&lang=js&external"
export * from "./PageSocialPartial.js?vue&type=script&lang=js&external"
import style0 from "./PageSocialPartial.scss?vue&type=style&index=0&id=d506842c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d506842c",
  null
  
)

export default component.exports